import modal from './modal-bottom';

const footer = document.querySelector('.m-footer');
const btnNewsletter = footer?.querySelector('.btn-newsletter');

btnNewsletter?.addEventListener('click', (e) => {
  e.preventDefault();
  modal.showModal();
});